module.exports = __webpack_public_path__ + "static/img/Icon4.5bea50c4.svg";